import { useState, useCallback } from "react";

// custom hook
const useHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = useCallback(async (requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      const headers = requestConfig.headers ? { ...requestConfig.headers } : {};
      if (token) {
        headers["Authorization"] = "Bearer " + token;
      }

      const response = await fetch(requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers: headers,
        body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
      });

      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem("token");
        window.location.reload();
        throw new Error("Session abgelaufen. Bitte neu einloggen.");
      }

      if (!response.ok) {
        throw new Error("Request failed!");
      }

      const data = await response.json();
      applyData(data);
    } catch (err) {
      setError(err.message || "Something went wrong!");
    }
    setIsLoading(false);
  }, []);

  return { isLoading, error, sendRequest };
  // it´s the same:
  // return { isLoading: isLoading, error: error, sendRequest: sendRequest };
};

export default useHttp;
